// @flow

import React, { Component } from 'react';
import { connect } from 'react-redux';
import { Field } from 'redux-form';
import { LabeledInput } from '../../../../form/labeledFields';
import { ReduxFormInput } from '../../../../form';
import {
  getEmail,
  getEmailEqual,
  getRequired,
} from '../../../../../store/formSettings/selectors';
import {
  email,
  required,
  equalTo,
} from '../../../../../helpers/formValidators';

type OwnProps = {|
  label: string,
  validation_label: string,
  placeholder: string,
  type?: string,
|};

type StateProps = {|
  emailError: string,
  requiredError: string,
  equalsError: string,
|};

type Props = OwnProps & StateProps;

class EmailConfirmation extends Component<Props, *> {
  static defaultProps = {
    type: 'email',
  };

  checkPastingEmail = (event: SyntheticKeyboardEvent<HTMLInputElement>) => {
    if (event.keyCode === 86 && (event.metaKey || event.ctrlKey)) {
      event.preventDefault();
    }
  }

  render() {
    const {
      label,
      type,
      validation_label,
      placeholder,
      emailError,
      requiredError,
      equalsError,
    } = this.props;
    const emailValid = email(emailError);
    const requiredValid = required(requiredError);
    const equalValidator = equalTo(equalsError, 'email-check');

    return (
      <div>
        <LabeledInput
          label={label}
        >
          <Field
            name="email-check"
            type={type}
            component={ReduxFormInput}
            placeholder={placeholder}
            validate={[requiredValid, emailValid]}
          />
        </LabeledInput>
        <LabeledInput
          label={validation_label}
        >
          <Field
            name="email"
            type={type}
            component={ReduxFormInput}
            placeholder={placeholder}
            validate={[requiredValid, emailValid, equalValidator]}
            onKeyDown={this.checkPastingEmail}
          />
        </LabeledInput>
      </div>
    );
  }
}

const mapStateToProps = (state): StateProps => ({
  emailError: getEmail(state),
  requiredError: getRequired(state),
  equalsError: getEmailEqual(state),
});

export default connect<any, OwnProps, StateProps, any, any, any>(
  mapStateToProps,
)(EmailConfirmation);
